import types from '@/actions/types';
import useSequence from '@/composables/useSequence';
import useConditions from '@/composables/useConditions';
import Base from '@/actions/base';
import useAnalytics from '@/composables/useAnalytics';
import useConfig from '@/composables/useConfig';

export default class Condition extends Base {
  constructor(params) {
    super(params, types.CONDITION);
  }

  execute() {
    const { runSequence } = useSequence();
    const { checkCondition } = useConditions();
    const { trackAction } = useAnalytics();
    const { setFlowStateBackToStart } = useConfig();
    trackAction(this);

    return new Promise((resolve) => {
      this.resolve = resolve;
      const { conditions, noMatch } = this.params;
      const match = conditions.find(checkCondition);

      resolve();
      if (match) {
        setFlowStateBackToStart(match.next);
        runSequence(match.next);
      } else if (noMatch) {
        setFlowStateBackToStart(noMatch);
        runSequence(noMatch);
      }
    });
  }

  stop() {
    this.resolve();
  }
}
